var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 88,
    height: 88,
    rx: 18,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2017 61V31.9091H38.4858V37.6193H25.233V43.5852H37.4489V49.3097H25.233V55.2898H38.4858V61H18.2017ZM67.6477 31.9091V61H61.6818L50.1051 44.2102H49.9205V61H42.8892V31.9091H48.9403L60.3892 48.6705H60.6307V31.9091H67.6477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnLang);
export default __webpack_public_path__ + "static/media/en-lang.b918ca2ae8193503e912143775b90808.svg";
export { ForwardRef as ReactComponent };